import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { TransactionStatusEnum } from '../../broker-commission-transactions/models/broker-commission-transaction.interface';
import { DealPaymentRailEnum } from '../../transactions/models/deal-payment-rail-status.enum';
import { DealTransactionStatusEnum } from './deal-transaction-status.enum';
import { ExternalDealReviewStatusEnum } from './external-deal-review-status.enum';
import { PartnerCommissionStatusEnum } from './partner-commission-status.enum';

export class ExternalDealCommissionFilter extends BaseListFilter {
  partnerId?: number;
  partnerName?: string;
  externalFirstName?: string;
  externalLastName?: string;
  userId?: number;
  fullName?: string;
  paymentDateFrom?: Date;
  paymentDateTo?: Date;
  changeReviewStatusFrom?: Date;
  changeReviewStatusTo?: Date;
  draftToReadyAtFrom?: Date;
  draftToReadyAtTo?: Date;
  createdAtFrom?: Date;
  createdAtTo?: Date;
  reviewStatus?: ExternalDealReviewStatusEnum | undefined;
  partnerStatus?: PartnerCommissionStatusEnum | undefined;
  transactionStatus?: DealTransactionStatusEnum | undefined;
  brokerCommissionTransactionStatus?: TransactionStatusEnum | undefined;
  paymentRail?: DealPaymentRailEnum;
  cdaId?: number;
  integrationId?: number;
  integrationName?: string;
  batchBrokerCommissionTransactionId?: number;

  constructor(
    public sortBy: string = 'draftToReadyAt',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
